import React from 'react';
import { PlmPartnerList } from './plmPartner-list';
import { Box } from '@mui/material';
import { useInjectableComponents } from '../../../system/services/injectableComponentsManager';

export function PlmPartnerMain() {
  const { setTitle, setTitlePath } = useInjectableComponents();

  React.useEffect(() => {
    setTitle('PLM Partners');
    setTitlePath('/plmPartners');
    return () => {
      setTitle(undefined);
      setTitlePath(undefined);
    };
  }, [setTitle, setTitlePath]);

  return (
    <Box sx={{ p: 2 }}>
      <PlmPartnerList />
    </Box>
  );
}
